const SUPPORTED_TEXT_DECORATION = 'underline';

const hasUnderlineStyle = (element) => {
  const { textDecoration } = element.style;
  return textDecoration.includes(SUPPORTED_TEXT_DECORATION);
};

export default hasUnderlineStyle;
